import type { IEnergyPassportDetails } from "@/entities/energy-passport/types.ts"
import {
  type ICustomOnChangeResult,
  type ITableEditableCell,
  TableEditableCell
} from "@/features/energy-passport/ui/detail-tables/components/table-editable-cell.tsx"
import { type IEnergyPassportDetailsStore, useEnergyPassportDetailsStore } from "@/features/energy-passport/ui/detail-tables/model/store.ts"
import { calcAllDetailsNeed } from "@/features/energy-passport/ui/main-table/model/lib.ts"
import { useCurrentUser } from "@/shared/hooks/use-current-user.ts"
import { showQuarterNumber } from "@/shared/lib/helper-functions.ts"
import type { ValueOf } from "@/shared/types/interfaces"

interface IProps {
  storeItem: ValueOf<IEnergyPassportDetailsStore>
  quarter: IEnergyPassportDetails
}

export function TableEditableRow({ storeItem, quarter }: IProps) {
  // Helpers
  const { isCompany } = useCurrentUser()

  // Store
  const { updateQuarter } = useEnergyPassportDetailsStore()

  // Functions
  const customOnChange = (data: ICustomOnChangeResult) => {
    updateQuarter(storeItem.type, {
      ...quarter,
      ...data
    })
  }

  const cells: ITableEditableCell[] = [
    {
      readonly: true,
      inputProps: {
        name: "declared_consumption",
        value: quarter.sub_consumption + quarter.total_consumption
      }
    },
    {
      customOnChange,
      inputProps: {
        name: "sub_consumption",
        value: quarter.sub_consumption
      }
    },
    {
      readonly: true,
      inputProps: {
        name: "total_consumption",
        value: calcAllDetailsNeed(quarter)
      }
    },
    {
      readonly: true,
      inputProps: {
        name: "technical_needs",
        value: quarter.technical_needs
      }
    },
    {
      customOnChange,
      inputProps: {
        name: "own_needs",
        value: quarter.own_needs
      }
    },
    {
      customOnChange,
      inputProps: {
        name: "production_needs",
        value: quarter.production_needs
      }
    },
    {
      customOnChange,
      inputProps: {
        name: "residential_needs",
        value: quarter.residential_needs
      }
    },
    {
      customOnChange,
      inputProps: {
        name: "consumption_standard",
        value: quarter.consumption_standard
      }
    },
    {
      customOnChange,
      inputProps: {
        name: "max_nominal_capacity_per_hour",
        value: quarter.max_nominal_capacity_per_hour
      }
    }
  ]

  return (
    <tr className="child-row remove-bg !py-0 transition">
      <td className={`!py-0 !px-0 !pl-3 ${isCompany ? "dark:bg-zinc-500 " : ""}`}>
        <div className="flex items-center gap-4 pl-[10px]">{showQuarterNumber(quarter.quarter)}</div>
      </td>
      <td className={`!py-0 !px-0 !pl-3 ${isCompany ? "dark:bg-zinc-500 " : ""}`} />
      {cells.map(TableEditableCell)}
    </tr>
  )
}
